import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delivery-address-list',
  templateUrl: './delivery-address-list.component.html',
  styleUrls: ['./delivery-address-list.component.css']
})
export class DeliveryAddressListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
